<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading>

<div class="flex">
  <form [formGroup]="form" action="">
    <div class="text-gray-900 bg-gray-200 main-table-form" style="width: 1000px">
      <div class="flex">
        <div class="">
          <fieldset form="form">
            <div class="flex p-3">
              <label for="iins" class="ml-2 cursor-pointer w-auto"> {{ 'SearchByIIN' | translate }}
              </label>
              <input (keydown.enter)="getFindNqtActionLogByIin()" formControlName="iin"
                     class="rounded-lg bg-white ml-10" type="text" placeholder="ИИН">
            </div>
          </fieldset>

          <button (click)="getFindNqtActionLogByIin()" type="button"
                  class="cursour-pointer w-40 bg-gray-300 hover:bg-gray-300 rounded-lg lg:px-3 py-1 ml-2 text-grey-dark text-sm">
            {{ 'Search' | translate }}
          </button>

        </div>
      </div>

      <div class="px-3 py-4 overflow-x-auto" style="height: 730px;">
        <div class="-my-2 py-2 sm:-mx-6 sm:px-6 lg:-mx-8 pr-10 lg:px-8">
          <table *ngIf="informWindow == true" class="min-w-full">
            <thead>
            <tr>
              <th class="px-6 py-3 border-b-2 border-gray-300 text-center text-sm leading-4 text-gray-500 tracking-wider">
                Id
              </th>
              <th class="px-6 py-3 border-b-2 border-gray-300 text-center text-sm leading-4 text-gray-500 tracking-wider">
                Действие
              </th>
              <th class="px-6 py-3 border-b-2 border-gray-300 text-center text-sm leading-4 text-gray-500 tracking-wider">
                Дата
              </th>
            </tr>
            </thead>
            <tbody class="bg-white">
            <tr class="border-2 border-gray-200 cursor-pointer hover:bg-gray-200" *ngFor="let inc of applicationList"
                [ngClass]="{'bg-gray-300': hoverOnStudent == inc.id}" (click)="oknoData(inc)">
              <td
                class="px-6 py-4 whitespace-no-wrap text-center border-b text-blue-900 border-gray-800 text-sm leading-5">
                {{ inc.id }}
              </td>
              <td
                class="px-6 py-4 whitespace-no-wrap text-center border-b text-blue-900 border-gray-800 text-sm leading-5">
                {{ inc.actionTypeDescr }}
              </td>
              <td
                class="px-6 py-4 whitespace-no-wrap text-center border-b text-blue-900 border-gray-800 text-sm leading-5">
                {{ inc.createdAt }}
              </td>

            </tbody>
          </table>
        </div>
      </div>
    </div>
  </form>
  <div *ngIf="informWindow == true" class="mt-3 ml-3 bg-white border-2 realy">
    <div *ngIf="hoverOnStudent" class="pl-2">

      <p> <b>Текущая занятость:</b>
        <span *ngIf="translate.currentLang == 'kz'"> {{ employmentTypeDto?.nameKaz }} </span>
        <span *ngIf="translate.currentLang == 'ru'"> {{ employmentTypeDto?.nameRus }} </span>
      </p>
      <p> <b>{{ 'FIO' | translate }}:</b> {{ studentDto?.lastname }}  {{ studentDto?.firstname }}  {{ studentDto?.patronymic }} </p>
      <p> <b>ИИН:</b> {{ studentDto?.iin }} </p>
      <p> <b>{{ 'ApplicationDate' | translate }}:</b> {{ createdAt }} </p>
      <p> <b>{{ 'phone' | translate }}:</b> {{ phoneNumber }} </p>
      <p> <b>{{ 'DeliveryLanguage' | translate }}: </b>
        <span *ngIf="translate.currentLang == 'kz'"> {{ langDto?.nameKaz }} </span>
        <span *ngIf="translate.currentLang == 'ru'"> {{ langDto?.nameRus }} </span> </p>
      <p> <b>email:</b>
        {{ studentDto?.email }}
      </p>
      <p *ngIf="jobTypeDto != null"> <b>Специальность:</b>
        <span *ngIf="translate.currentLang == 'kz'"> {{ jobTypeDto?.nameKaz }} </span>
        <span *ngIf="translate.currentLang == 'ru'"> {{ jobTypeDto?.nameRus }} </span>
      </p>
      <p *ngIf="testOrgDto != null"> <b>Область места работы/обучения:</b>
        <span *ngIf="translate.currentLang == 'kz'"> {{ testOrgDto?.nameKaz }} </span>
        <span *ngIf="translate.currentLang == 'ru'"> {{ testOrgDto?.nameRus }} </span>
      </p>
      <p *ngIf="jobDto != null"> <b>Место работы/обучения:</b>
        <span *ngIf="translate.currentLang == 'kz'"> {{ jobDto?.nameKaz }} </span>
        <span *ngIf="translate.currentLang == 'ru'"> {{ jobDto?.nameRus }} </span>
      </p>
      <p *ngIf="testStatusDto != null"> <b>Статус:</b>
        <span *ngIf="translate.currentLang == 'kz'"> {{ testStatusDto?.nameKaz }} </span>
        <span *ngIf="translate.currentLang == 'ru'"> {{ testStatusDto?.nameRus }} </span>
      </p>
    </div>
  </div>
</div>
